import { h, Component } from "preact";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import { Common, NewCommon } from "./wrappers";

const safe = (cb, or = null) => {
	try {
		return cb();
	} catch (e) {
		return or;
	}
};

export default class BasketTracker extends Component {
	render({ event, lastEventName = event.misc.tracker.name || "" }) {
		if (!event.misc.info)
			return null;
		return <Common event={event}>
			<div class={"field field-" + event.misc.info.field}>
				<div
					class={`animation-container ${lastEventName} ${event.misc.tracker.team} ${
						event.misc.tracker.team == "home" ? 1 : 2
					}`}
				>
					<div class="infoPhase">
						<span className="infoPhase_label">{event.status.phase}</span>
						<span class="infoPhase_score">
							{safe(() => event.misc.stats.set.team1_value)}:{safe(() => event.misc.stats.set.team2_value)}
							<span>
								({safe(() => event.misc.stats.score.team1_value)}-{safe(() => event.misc.stats.score.team2_value)})
							</span>
						</span>
					</div>
					<div>
						{lastEventName === "FreeThrow" ||
						lastEventName === "Free1Throw" ||
						lastEventName === "Free2Throws" ||
						lastEventName === "Free3Throws"
							? [
									<div key="FreeThrow-basket" class="basket" />,
									<div key="FreeThrow-arrow" class="arrow" />,
									<div key="FreeThrow-b_ball" class="b_ball" />,
							  ]
							: null}
						{lastEventName === "Attack" ? (
							<div class="attack-div">
								<div class="attack-dir" />
							</div>
						) : null}
						{lastEventName === "OnePoint" || lastEventName === "TwoPoints" || lastEventName === "ThreePoints"
							? [
									<div key="Points-basket" class="basket" />,
									<div key="Points-ball_container" class="ball_container">
										<div class="b_ball" />
									</div>,
							  ]
							: null}

						{lastEventName !== "Foul" ? (
							<div class="text-event" title={lastEventName}>
								{lastEventName.replace(/[A-Z]/g, (letter, idx) => (idx == 0 ? letter : ` ${letter}`))}
							</div>
						) : null}

						{lastEventName === "Foul" ? (
							<div class="timeout-container">
								<div title={lastEventName}>{lastEventName}</div>
								<div>{event.teams[event.misc.tracker.team].name}</div>
							</div>
						) : null}
					</div>
				</div>
			</div>
		</Common>;
	}
}
